
/** by MVinfo / Walcledson de Paula 8/8/24w
 * p-menu.jsx
 * alterações 02/08/24
 * no PC manter o tamanho;
 * no Tablet ou Notebook com telas menores diminuir o tamanho do menu;
 * no celular, deve ficar grudado na parte inferior do celular;
 * alterações: 14/08/24 | 16h04
 * alterações: 22/09/24 | 17h23 - acrescentamos a condição TipoAtendimento (0=sem funcionário / 1=com funcionários) que mostra ou não mostra o menu Colaboradores;
 * alterações: 08/11/24 | 21h40 - acrescentamos o menu "Regras Atendimento" que inclui "Dias/Horários" e "Feriados que não atende". Tiramos "TipoAtendimento" do "Home" e trouxemos para cá também;
 * 
* src/app/agendexPrestador/components/menu/p_menu.jsx
*/

import React, { useState, useEffect, Component } from 'react';
import { Link, useNavigate } from "react-router-dom";
import { p_getUserData } from '../../../../Services/p_userutils';

import imgLogomarca from '../../../../Assets/agendex/logoagendexprestador.png';
import imgLogoMini from '../../../../Assets/agendex/iconLogoAgendex.png';
import Icon from '@mdi/react'; // icone do material design icones pra padronizar o home do mobile/desktop (delphi) no web 2/7/24w
import { mdiHome, mdiCalendarClock, mdiAccountCircle, mdiStoreCogOutline, mdiPlusNetworkOutline, mdiAccountMultipleCheck, mdiStoreSettingsOutline  } from '@mdi/js'; // colaboradores

import './p_menu.css';

function CMenu(props) {
    const navigate = useNavigate();

    // verifica se é Mobile, tablet, NP, PC, etc
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const activeLink = "nav-link active";
    const inactiveLink = "nav-link text-black";

    const initialUserData = p_getUserData();
    const [tipoAtendimento, setTipoAtendimento] = useState(initialUserData.tipoAtendimento); // 0 = não possui colaboradores, 1 = possui colaboradores


    return (
        <>
            {/* Menu lateral esquerdo para telas maiores */}
            <div className={`d-flex flex-column flex-shrink-0 text-bg-white ${isMobile ? 'd-none' : 'p-3 bg-white'}`} id="menu">
                <a href="/app/prestador/home" className="d-flex align-items-center mb-3 mb-md-0 me-md-auto text-white text-decoration-none">
                    <img src={isMobile ? imgLogoMini : imgLogomarca} className="img-logo" alt="logo" /><br/>
                </a>
                <p></p>
                <ul className="nav nav-pills flex-column mb-auto">
                    <hr/>
                    <li className="nav-item">
                        <Link to="/app/prestador/home" className={props.page === "home" ? activeLink : inactiveLink} aria-current="page">
                            <Icon path={mdiHome} size={1} className='me-2'
                                title="Página principal/Dashboard"/>Home
                        </Link> 
                    </li>
                    <li className="nav-item">
                        <Link to="/app/prestador/empresa" className={props.page === "detalheempresa" ? activeLink : inactiveLink} aria-current="page">
                            <Icon path={mdiStoreCogOutline} size={1} className='me-2' 
                                title="Detalhes de sua empresa / negócio"/>Empresa
                        </Link>
                    </li>

                    <li className="nav-item">
                        <Link to="/app/prestador/empresa/servicos" className={props.page === "servicos" ? activeLink : inactiveLink} aria-current="page">
                            <Icon path={mdiPlusNetworkOutline} size={1} className='me-2'
                                title="Serviços a oferecer para seus clientes"/>Serviços
                        </Link>
                    </li>

                    <li className="nav-item">
                        <Link to="/app/prestador/empresa/regras" className={props.page === "regras" ? activeLink : inactiveLink} aria-current="page">
                            <Icon path={mdiStoreSettingsOutline } size={1} className='me-2'
                                title="Horários geral que seu estabelecimento trabalha"/>Regras de Atendimento
                        </Link>
                    </li>

                    <li className="nav-item">
                        { tipoAtendimento === 1 ? ( 
                        // {(props.colaboradores === 1 )? ( 
                            // {menuAtivo ? (
                            <Link to="/app/prestador/empresa/colaboradores" className={props.page === "colaboradores" ? activeLink : inactiveLink} aria-current="page">
                                <Icon path={mdiAccountMultipleCheck} size={1} className='me-2'
                                    title="Colaboradores, funcionários e/ou parceiros"/>Colaboradores
                            </Link>
                        ) : (
                            <span className={`${inactiveLink} text-muted`} title='Disponível apenas para o "Tipo de Atendimento Com Colaboradores"'>
                                <Icon path={mdiAccountMultipleCheck} size={1} className='me-2' />Colaboradores
                            </span>
                        )}
                    </li>

                    {/* ******* menu agendamentos ******** */}
                    <li className="nav-item dropdown">
                        <a className="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                            {/* <i className="bi bi-calendar"></i><span className="ms-1 d-none d-sm-inline">Agendamentos</span> */}
                            <Icon path={mdiCalendarClock} size={1}
                                title="ver meus agendamentos (abertos, concluídos, excluídos e pendentes)"/> Agendamentos
                        </a>
                        <ul className="dropdown-menu">
                            <li>
                                <Link to="/app/prestador/agendamentos/abertos" className={props.page === "agendamentosabertos" ? activeLink : inactiveLink} aria-current="page">
                                    <i className="bi bi-calendar2-date-fill"></i> <span className="ms-1 d-none d-sm-inline menu-title">Abertos</span>
                                </Link>
                            </li>
                            <li>
                                <Link to="/app/prestador/agendamentos/concluidos" className={props.page === "agendamentosconcluidos" ? activeLink : inactiveLink}>
                                    <i className="bi bi-check2-circle"></i> <span className="ms-1 d-none d-sm-inline menu-title">Concluídos</span>
                                </Link>
                            </li>
                            <li>
                                <Link to="/app/prestador/agendamentos/excluidos" className={props.page === "agendamentosexcluidos" ? activeLink : inactiveLink}>
                                    <i className="bi bi-x-circle"></i> <span className="ms-1 d-none d-sm-inline menu-title">Excluídos</span>
                                </Link>
                            </li>
                            <li>
                                <Link to="/app/prestador/agendamentos/pendentes" className={props.page === "agendamentospendentes" ? activeLink : inactiveLink}>
                                    <i className="bi bi-clock"></i> <span className="ms-1 d-none d-sm-inline menu-title">Pendentes</span>
                                </Link>
                            </li>
                        </ul>
                    </li>
                    {/* ******* menu agendamentos ******** */}

                    {/* ******* menu perfil ******** */}
                    <li className="nav-item">
                        <Link to="/app/prestador/perfil" className={props.page === "perfil" ? activeLink : inactiveLink} aria-current="page">
                            <Icon path={mdiAccountCircle} size={1} 
                                title="Acessar seus dados pessoais"
                            /> Perfil
                        </Link> 
                    </li>
                    {/* ******* menu perfil ******** */}
                </ul>
            </div>

            {/* Menu horizontal inferior para dispositivos móveis */}
            {isMobile && (
                <div className="bottom-menu d-flex justify-content-between align-items-center bg-light p-1 fixed-bottom" style={{ height: '50px' }}>
                    {/* Botões do menu horizontal */}
                    <Link to="/app/prestador/home" className={props.page === "home" ? activeLink : inactiveLink}>
                        <Icon path={mdiHome} size={1}
                            title="Página principal/Dashboard"/>
                    </Link>

                    <Link to="/app/prestador/empresa" className={props.page === "detalheempresa" ? activeLink : inactiveLink}>
                        <Icon path={mdiStoreCogOutline} size={1}
                            title="Detalhes de sua empresa / negócio"/>
                    </Link>

                    <Link to="/app/prestador/empresa/servicos" className={props.page === "servicos" ? activeLink : inactiveLink}>
                        <Icon path={mdiPlusNetworkOutline} size={1}
                            title="Serviços a oferecer para seus clientes"/>
                    </Link>

                    <Link to="/app/prestador/empresa/regras" className={props.page === "regras" ? activeLink : inactiveLink}>
                        <Icon path={mdiStoreSettingsOutline} size={1}
                            title="Regras de Atendimento: Dias/Horários e Feriados"/>
                    </Link>

                    {/* {tipoAtendimento === 1 ? (
                        <Link to="/app/prestador/empresa/colaboradores" className={props.page === "colaboradores" ? activeLink : inactiveLink} aria-current="page">
                            <Icon path={mdiAccountMultipleCheck} size={1} className='me-2'
                                title="Colaboradores, funcionários e/ou parceiros"/>Colaboradores
                        </Link>
                    ) : (
                        <span className={`${inactiveLink} text-muted`} title='Disponível apenas para o "Tipo de Atendimento Com Colaboradores"'>
                            <Icon path={mdiAccountMultipleCheck} size={1} className='me-2' />Colaboradores
                        </span>
                    )} */}

                    {tipoAtendimento === 1 ? (
                        <Link to="/app/prestador/empresa/colaboradores" className={props.page === "colaboradores" ? activeLink : inactiveLink}>
                            <Icon path={mdiAccountMultipleCheck} size={1}
                                title="Colaboradores, funcionários e/ou parceiros"/>
                        </Link>
                    ) : (
                        <span className={`${inactiveLink} text-muted`} title='Disponível apenas para o "Tipo de Atendimento Com Colaboradores"'>
                            <Icon path={mdiAccountMultipleCheck} size={1} className='me-2' />
                        </span>
                    )}

                    {/* ******* menu agendamentos ******** */}
                    <div className="dropdown">
                        <a className={`nav-link dropdown-toggle ${props.page.startsWith("agendamentosabertos") ? activeLink : inactiveLink}`} href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                            <Icon path={mdiCalendarClock} size={1}/>
                        </a>

                        <ul className="dropdown-menu">
                            <li>
                                <Link to="/app/prestador/agendamentos/abertos" className={props.page === "agendamentosabertos" ? activeLink : inactiveLink} aria-current="page">
                                    <i className="bi bi-calendar2-date-fill"></i> <span className="ms-1 d-sm-inline menu-title">Abertos</span>
                                </Link>
                            </li>
                            <li>
                                <Link to="/app/prestador/agendamentos/concluidos" className={props.page === "agendamentosconcluidos" ? activeLink : inactiveLink}>
                                    <i className="bi bi-check2-circle"></i> <span className="ms-1 d-sm-inline menu-title">Concluídos</span>
                                </Link>
                            </li>
                            <li>
                                <Link to="/app/prestador/agendamentos/excluidos" className={props.page === "agendamentosexcluidos" ? activeLink : inactiveLink}>
                                    <i className="bi bi-x-circle"></i> <span className="ms-1 d-sm-inline menu-title">Excluídos</span>
                                </Link>
                            </li>
                            <li>
                                <Link to="/app/prestador/agendamentos/pendentes" className={props.page === "agendamentospendentes" ? activeLink : inactiveLink}>
                                    <i className="bi bi-clock"></i> <span className="ms-1 d-sm-inline menu-title">Pendentes</span>
                                </Link>
                            </li>
                        </ul>
                    </div>
                    {/* ******* menu agendamentos ******** */}


                    {/* ******* menu perfil ******** */}
                    <Link to="/app/prestador/perfil" className={props.page === "perfil" ? activeLink : inactiveLink} aria-current="page">
                        <Icon path={mdiAccountCircle} size={1} 
                            title="Acessar seus dados pessoais"
                        />
                    </Link> 
                    {/* ******* menu perfil ******** */}
                </div>
            )}
        </>
    );
}

export default CMenu;